import React, { useEffect } from "react";
import ViewMaster from "../../Components/ViewMaster/ViewMaster";

function Privacy() {
  useEffect(() => {
    document.title = "Zesty games | Privacy Policy & Terms of Use";
  }, []);
  return (
    <>
      <div>
        <div className="bgContent" style={{ "background-color": "#ffffff" }}>
          <div className="container py-4 text-white fs-20 txblack">
            <div className="txblack">
              <h4 className="DescriptionHeading">
                <strong>Global Privacy Policy for ZestyGame.com</strong>
              </h4>
              <div>
                <p>
                  <strong>Introduction</strong>
                </p>

                <p>
                  At ZestyGame.com, your privacy is of utmost importance to us.
                  This Privacy Policy explains how we collect, use, and protect
                  your personal information when you visit our website and use
                  our services. We are dedicated to being transparent about our
                  data practices.
                </p>

                <p>
                  <strong>Information Collection</strong>
                </p>

                <p>
                  We may collect the following types of information when you use
                  ZestyGame.com:
                </p>

                <p>
                  <strong>Personal Information:</strong> This includes details
                  you provide voluntarily, such as your name and email address.
                </p>
                <p>
                  <strong>Automatic Data:</strong> We automatically gather
                  information like your IP address, browser type, and usage
                  patterns to improve your experience on our site.
                </p>

                <p>
                  <strong>Use of Your Data</strong>
                </p>

                <p>We use your information for the following purposes:</p>

                <p>- To enhance and maintain our website and services.</p>
                <p>- To communicate with you regarding inquiries or updates.</p>
                <p>- To personalize your gaming experience.</p>
                <p>- To comply with legal obligations.</p>

                <p>
                  <strong>Data Sharing</strong>
                </p>

                <p>
                  We do not share your personal information with third parties,
                  except for necessary payment processing or as required by law.
                  We encourage you to review the privacy policies of any
                  third-party services we may use.
                </p>

                <p>
                  <strong>Data Retention</strong>
                </p>

                <p>
                  We retain your personal information only as long as necessary
                  to fulfill your requests and comply with legal requirements.
                  You can request the deletion of your data at any time.
                </p>

                <p>
                  <strong>Age Restrictions</strong>
                </p>

                <p>
                  ZestyGame.com is intended for users of all ages. If a game
                  requires players to be at least 13 years old, we may ask for
                  age verification. Users under 13 will be directed to
                  age-appropriate content.
                </p>

                <p>
                  <strong>Security Measures</strong>
                </p>

                <p>
                  We implement technical and organizational measures to protect
                  your information from unauthorized access. However, please
                  exercise caution when sharing personal information online, as
                  no system is entirely secure.
                </p>

                <p>
                  <strong>No Gambling Content</strong>
                </p>

                <p>
                  ZestyGame.com does not offer gambling-related content. There
                  is no real-world value for virtual items in our games, and no
                  financial transactions are required for gameplay.
                </p>

                <p>
                  <strong>Changes to This Policy</strong>
                </p>

                <p>
                  We may update this Privacy Policy periodically. Significant
                  changes will be posted on our website, and we encourage you to
                  review this policy regularly.
                </p>

                <p>
                  <strong>Your Rights</strong>
                </p>

                <p>
                  You have the right to access, correct, or delete your personal
                  information. If you have questions or concerns about our
                  privacy practices, please contact us.
                </p>

                <p>
                  By using ZestyGame.com, you consent to the terms of this
                  Privacy Policy. Thank you for being a part of our gaming
                  community!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewMaster(Privacy);
